import { Role } from '../../api/RoleManagement';
import { RootState } from '../reducers';

export function isEmployeeWarehouseOwner(state: RootState): boolean {
    return !!state.loggedEmployee.readableRoles?.find((r) => r === Role.WarehouseOwner);
}

export function isEmployeeWarehouseManager(state: RootState): boolean {
    return !!state.loggedEmployee.readableRoles?.find((r) => r === Role.WarehouseManager);
}

export function isEmployeeProjectManager(state: RootState): boolean {
    return !!state.loggedEmployee.readableRoles?.find((r) => r === Role.ProjectManager);
}

export function isEmployeeProjectAdmin(state: RootState): boolean {
    return !!state.loggedEmployee.readableRoles?.find((r) => r === Role.ProjectAdmin);
}

export function isEmployeeProcurementManager(state: RootState): boolean {
    return !!state.loggedEmployee.readableRoles?.find((r) => r === Role.ProcurementManager);
}

export function isEmployeeSystemAdmin(state: RootState): boolean {
    return !!state.loggedEmployee.readableRoles?.find((r) => r === Role.SystemAdmin);
}

export function isEmployeeFinanceManager(state: RootState): boolean {
    return !!state.loggedEmployee.readableRoles?.find((r) => r === Role.FinanceManager);
}

/** WarehouseOwner who is NOT also a ProjectManager or WarehouseManager (lowest-privilege owner). */
export function isEmployeeWarehouseOwnerOnly(state: RootState): boolean {
    const roles = state.loggedEmployee.readableRoles;
    const higherRoles = roles?.filter((r) => {
        return r === Role.ProjectManager || r === Role.WarehouseManager;
    });

    if (!!higherRoles && higherRoles.length > 0) {
        return false;
    }

    return !!roles?.find((r) => r === Role.WarehouseOwner);
}

export function canManipulateGoods(state: RootState): boolean {
    const roles = state.loggedEmployee.readableRoles;

    return !!roles?.find((r) => r === Role.WarehouseOwner || r === Role.WarehouseManager || r === Role.ProjectManager);
}

export function canInstallGoods(state: RootState): boolean {
    const roles = state.loggedEmployee.readableRoles;

    return !!roles?.find((r) => r === Role.WarehouseOwner || r === Role.ProjectManager);
}

export function canManipulateSites(state: RootState): boolean {
    const roles = state.loggedEmployee.readableRoles;

    return !!roles?.find((r) => r === Role.WarehouseManager || r === Role.ProjectManager);
}

export function canManipulateProjects(state: RootState): boolean {
    const roles = state.loggedEmployee.readableRoles;

    return !!roles?.find((r) => r === Role.ProjectAdmin);
}

export function canManipulateClients(state: RootState): boolean {
    const roles = state.loggedEmployee.readableRoles;

    return !!roles?.find((r) => r === Role.ProjectManager || r === Role.ProjectAdmin);
}

export function canManipulateSuppliers(state: RootState): boolean {
    const roles = state.loggedEmployee.readableRoles;

    return !!roles?.find((r) => r === Role.ProcurementManager || r === Role.ProjectAdmin);
}

export function canSeeValuableInfo(state: RootState): boolean {
    const roles = state.loggedEmployee.readableRoles;

    return !!roles?.find((r) => r === Role.FinanceManager);
}

export function canSeeProductTemplates(state: RootState): boolean {
    const roles = state.loggedEmployee.readableRoles;

    return !!roles?.find((r) => r === Role.FinanceManager || r === Role.CEO);
}

export function isEmployeeListed(azObjIds: string[]): (state: RootState) => boolean {
    return function (state: RootState): boolean {
        const empId = state.loggedEmployee.basicEmployee?.id;

        return !!empId ? azObjIds.includes(empId) : false;
    };
}
